import { Routes } from "@angular/router";
import { actionsGuard } from "../shared/guards/actions.guard";
import { ServiciosListComponent } from "./servicios-list/servicios-list.component";
import { ServicioCreateComponent } from "./servicio-create/servicio-create.component";
import { ServicioDetailsComponent } from "./servicio-details/servicio-details.component";
import { ServicioEditComponent } from "./servicio-edit/servicio-edit.component";

export const serviciosRoutes: Routes = [
  { path: '', redirectTo: 'list', pathMatch: 'full' },
  { path: 'list', component: ServiciosListComponent, canActivate: [actionsGuard] },
  { path: 'create', component: ServicioCreateComponent, canActivate: [actionsGuard] },
  { path: 'edit/:id', component: ServicioEditComponent, canActivate: [actionsGuard] },
  // { path: 'delete/:id', component: PermissionsDeleteComponent, canActivate: [actionsGuard] },
  { path: 'details/:id', component: ServicioDetailsComponent, canActivate: [actionsGuard] },
]
